import { NotesDisplayColumn } from './NotesDisplay';

// Engagement Details Notes Configuration
export const ENGAGEMENT_NOTES_COLUMNS: NotesDisplayColumn[] = [
  { id: 'topic', label: 'Topic', align: 'center' },
  { id: 'author', label: 'Author', align: 'left' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'date', label: 'Date', align: 'center' },
  { id: 'medium', label: 'Medium', align: 'center' },
];

// CRS Sections Notes Configuration (Patient Details, Case Details, Referral Details)
export const CRS_NOTES_COLUMNS: NotesDisplayColumn[] = [
  { id: 'topic', label: 'Topic', align: 'center' },
  { id: 'author', label: 'Author', align: 'left' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'date', label: 'Date', align: 'center' },
  { id: 'medium', label: 'Medium', align: 'center' },
];

// Care Plan Notes Configuration
export const CAREPLAN_NOTES_COLUMNS: NotesDisplayColumn[] = [
  { 
    id: 'date', 
    label: 'Date', 
    align: 'left',
    render: (date: Date | null) => {
      if (!date) return 'N/A';
      const moment = require('moment');
      return `${moment(date).format('MMM DD Y')} - ${moment(date).format('hh:mm A')}`;
    }
  },
  { 
    id: 'type', 
    label: 'Type/Tool', 
    align: 'left',
    render: (source: any) => {
      if (!source?.concept?.coding) return 'N/A';
      
      const contactType = source.concept.coding.find(
        (c: any) => c.system === 'http://fhir.system/extension/ActivityDefinition/contactType'
      );
      const assessment = source.concept.coding.find(
        (c: any) => c.system === 'http://fhir.system/extension/ActivityDefinition/dst'
      );

      return assessment || contactType 
        ? `${contactType ? contactType.display : 'N/A'} ${assessment ? `/ ${assessment.display}` : ''}`
        : 'N/A';
    }
  },
  { 
    id: 'source', 
    label: 'Source', 
    align: 'left',
    render: (source: any) => {
      if (source?.reference?.type === 'Task') {
        return 'Activity';
      }
      return source?.concept?.text ?? 'General Note';
    }
  },
  { 
    id: 'text', 
    label: 'Note', 
    align: 'left',
    render: (value: string) => {
      if (!value) return 'N/A';
      const parse = require('html-react-parser').default;
      return parse(value);
    }
  },
  { 
    id: 'author', 
    label: 'Author', 
    align: 'left',
    render: (author: any) => {
      return author?.display ?? 'N/A';
    }
  },
];

// Simple Notes Configuration (for annotations)
export const SIMPLE_NOTES_COLUMNS: NotesDisplayColumn[] = [
  { id: 'text', label: 'Note', align: 'left' },
  { id: 'author', label: 'Author', align: 'left' },
  { id: 'date', label: 'Date', align: 'left' },
];

export const createCustomNotesColumns = (columns: Pick<NotesDisplayColumn, 'id' | 'label'> & Partial<Omit<NotesDisplayColumn, 'id' | 'label'>>[]): NotesDisplayColumn[] => {
  return columns.map(col => ({
    align: 'left',
    ...col,
  } as NotesDisplayColumn));
};
